import { build } from "../../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/profile/dispatcher-details",
		component: lazy(() => import("./DispatcherPage")),
	},
]);
